<script>
    import { fly } from "svelte/transition";
    import {
        Input,
        Button,
        Grid,
        GridItem,
        Cell,
        CellGroup,
        Form,
        FormItem,
    } from "../index";

    let inputType = "password";
    function handlePass() {
        if (inputType === "password") {
            inputType = "text";
        } else {
            inputType = "password";
        }
    }
</script>

<div class="example" transition:fly={{ x: 200 }}>
    


    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Input placeholder="请输入" />
    </div>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Input type="number" placeholder="请输入数字" />
    </div>

    <h4 class="example-title">输入内容右对齐</h4>
    <div class="example-body">
        <Input placeholder="请输入" --text-align="right" />
    </div>
    <h4 class="example-title">只读状态</h4>
    <div class="example-body">
        <Input
            placeholder="请输入"
            value="永远相信美好的事情即将发生"
            readonly
        />
    </div>
    <h4 class="example-title">禁用状态</h4>
    <div class="example-body">
        <Input
            placeholder="请输入"
            value="永远相信美好的事情即将发生"
            disabled
        />
    </div>
    <h4 class="example-title">查看密码</h4>
    <div class="example-body">
        <Grid columns={4}>
            <GridItem span={3}
                ><Input type={inputType} placeholder="请输入密码" /></GridItem
            >
            <GridItem
                ><Button color="primary" size="mini" on:click={handlePass}
                    >切换</Button
                ></GridItem
            >
        </Grid>
    </div>

    <h4 class="example-title">配合列表使用-水平布局</h4>
    <div class="example-body nopadding">
        <Form>
            <FormItem label="用户名" id="userName"
                ><Input placeholder="请输入" id="userName" /></FormItem
            >
            <FormItem label="密码" id="pass" clickable={false}>
                <Input type="password" id="pass" placeholder="请输入" />
            </FormItem>
        </Form>
    </div>
    <h4 class="example-title">配合列表使用-垂直布局</h4>
    <div class="example-body nopadding">
        <Form layout='vertical'>
            <FormItem label="用户名" id="userName1" 
                ><Input placeholder="请输入" id="userName1" /></FormItem
            >
            <FormItem label="密码" id="pass1" clickable={false}>
                <Input type="password" id="pass1" placeholder="请输入" />
            </FormItem>
        </Form>
    </div>
    <h4 class="example-title">配合列表使用-箭头</h4>
    <div class="example-body nopadding">
        <Form layout='vertical'>
            <FormItem label="用户名" id="userName12" clickable 
                ><Input placeholder="请选择" readonly id="userName12" /></FormItem
            >
        </Form>
    </div>

    
</div>

<style lang="less">
    @import "./example.less";
    .nopadding {
        padding: 0;
    }
</style>
